import { videoPlayed, videoPaused, videoEnded } from "../src/segment-tracks.js";
import { win } from "./lib/pd-window.js";

// Tracks the scroll position at the time the popover opened so it can be
// restored when it closes. Also serves as a guard against double-locking
// when multiple Wistia embeds exist on a page.
/** @type {number | null} */
let _popoverScrollY = null;

function lockBodyScroll() {
  if (_popoverScrollY !== null) return;
  _popoverScrollY = win.scrollY;
  document.body.style.position = "fixed";
  document.body.style.top = `-${_popoverScrollY}px`;
  document.body.style.left = "0";
  document.body.style.right = "0";
}

function unlockBodyScroll() {
  if (_popoverScrollY === null) return;
  const scrollY = _popoverScrollY;
  _popoverScrollY = null;
  document.body.style.position = "";
  document.body.style.top = "";
  document.body.style.left = "";
  document.body.style.right = "";
  win.scrollTo({ top: scrollY, behavior: "instant" });
}

win._wq = win._wq || [];

win._wq.push({
  id: "_all",
  onReady: function (
    /** @type {{ data: { media: { hashedId: any; duration: number; name: any; }; }; bind: (arg0: string, arg1: { (): void; (): void; (): void; }) => void; time: () => number; }} */ video,
  ) {
    let options = {
      video_id: video.data.media.hashedId,
      video_duration: Math.round(video.data.media.duration),
      video_current_time: Math.round(video.time()) || 0,
      video_percent:
        Math.round((video.time() / video.data.media.duration) * 100) || 0,
      video_provider: "wistia",
      video_title: video.data.media.name || "NA",
      video_url: "NA",
    };

    video.bind("play", function () {
      options.video_current_time = Math.round(video.time()) || 0;
      options.video_percent =
        Math.round((video.time() / options.video_duration) * 100) || 0;
      videoPlayed(options);
    });

    video.bind("pause", function () {
      options.video_current_time = Math.round(video.time()) || 0;
      options.video_percent =
        Math.round((video.time() / options.video_duration) * 100) || 0;
      videoPaused(options);
    });

    video.bind("end", function () {
      options.video_percent =
        Math.round((video.time() / options.video_duration) * 100) || 0;
      videoEnded(options);
    });

    // Lock body scroll when a Wistia popover opens to prevent the
    // position:absolute overlay from shifting on mobile as the browser
    // chrome (address bar) or scroll momentum changes scrollY.
    // Uses the iOS scroll-lock pattern: fix the body at the current scroll
    // position, then restore on hide. This also ensures touch events on the
    // player controls are not intercepted as scroll gestures (which caused
    // the fullscreen/volume buttons to be unresponsive on iOS).
    video.bind("popovershow", lockBodyScroll);
    video.bind("popoverhide", unlockBodyScroll);
  },
});
